import * as Http from "../http";
import {
  AccountType,
  AccountTypeName,
  INTERMEDIATE_OUTPUT_FILES,
  REPORT_NAME_MAPPING,
} from "../const";
import moment from "moment";

let AlertFunc = null;
let RoleGroupName = "";
let ListRoleOfUser = [];
const ScreenSize = { width: 0, height: 0 };

export function convertToDate(date) {
  if (!date) return "";
  return moment(date).format("DD/MM/YYYY");
}

export function convertToFullDate(date) {
  if (!date) return "";
  return moment(date).format("DD/MM/YYYY HH:mm:ss");
}

export function convertFileStatus(fileStatus) {
  return FILE_STATUS_MAP[fileStatus] || "";
}

export function convertUploadType(uploadType) {
  return UPLOAD_TYPE_MAP[uploadType] || "";
}

export function isHasRole(lstRoleNameRequire = []) {
  if (lstRoleNameRequire.includes(ROLE_DEFINE_MAP.DISABLE)) {
    return false;
  }
  // return true;
  if (
    lstRoleNameRequire.length === 0 ||
    lstRoleNameRequire.includes(ROLE_DEFINE_MAP.NO_ROLE)
  ) {
    return true;
  }

  for (let i = 0; i < lstRoleNameRequire.length; i++) {
    const roleName = lstRoleNameRequire[i];
    if (ListRoleOfUser.includes(roleName)) {
      return true;
    }
  }
  return false;
}

export function setUserRoles(roleGroupName, lstUserRoles = []) {
  ListRoleOfUser = [];
  RoleGroupName = roleGroupName;
  lstUserRoles.forEach((role) => {
    if (role && role.select === "1") {
      ListRoleOfUser.push(role.roleName);
    }
  });
}

export function toBaseURL(fullURL) {
  return fullURL ? fullURL.match(/^https?:\/\/[^#?\/]+/)[0] : "";
}

export function setSizeScreen(width, height) {
  ScreenSize.width = width;
  ScreenSize.height = height;
}

export function getSizeScreen() {
  return { ...ScreenSize };
}

export function getHeightContent() {
  let height = getSizeScreen().height;
  if (height > 0) height = height - 75 - 20 - 50 - 20;
  return height;
}

export function getAccountTypeName(accountType) {
  return AccountTypeName[accountType] || "";
}

export function getAccountTypeId(accountTypeName) {
  return AccountType[accountTypeName] || "";
}

export function isAdmin() {
  const currentAcc = Http.getCurrentUserInfo();
  return currentAcc.AccountType === AccountType.Admin;
}

export function isCurrentUser(username) {
  const currentAcc = Http.getCurrentUserInfo();
  return currentAcc && currentAcc.Username === username;
}

export function getRoleById(roleId) {
  const listRole = Http.getRoleGroup();
  return listRole.find((item) => item.RoleGroupId === roleId) || {};
}

export function getRoleName(roleId) {
  const role = getRoleById(roleId);
  return role.RoleGroupName || "";
}

export function getAllRoleName() {
  const listRole = Http.getRoleGroup();
  return listRole.map((item) => item.RoleGroupName);
}

export function getRoleIdByName(rolename) {
  const listRole = Http.getRoleGroup();
  const role = listRole.find((item) => item.RoleGroupName === rolename) || {};
  return role.RoleGroupId || null;
}

export function getFirstRoleId() {
  const listRole = Http.getRoleGroup();
  return listRole[0].RoleGroupId;
}

export function getRawListRole() {
  return [
    { roleId: 1, roleName: "Create User", select: "2" },
    { roleId: 2, roleName: "Update User", select: "2" },
    { roleId: 3, roleName: "Delete User", select: "2" },
    { roleId: 4, roleName: "Edit Parameters", select: "2" },
    { roleId: 5, roleName: "CAR Approval Files", select: "2" },
    { roleId: 6, roleName: "ICAAP Approval Files", select: "2" },
    { roleId: 7, roleName: "CAR Upload Files", select: "2" },
    { roleId: 8, roleName: "ICAAP Upload Files", select: "2" },
    { roleId: 9, roleName: "Capital Planning Save", select: "2" },
    { roleId: 10, roleName: "CAR View Report", select: "2" },
    { roleId: 11, roleName: "ICAAP View Report", select: "2" },
    { roleId: 12, roleName: "Capital Planning View Report", select: "2" },
    { roleId: 13, roleName: "CAR Delete Report", select: "2" },
    { roleId: 14, roleName: "ICAAP Delete Report", select: "2" },
    { roleId: 15, roleName: "Capital Planning Delete Report", select: "2" },
    { roleId: 16, roleName: "Create Role", select: "2" },
    { roleId: 17, roleName: "Update Role", select: "2" },
    { roleId: 18, roleName: "CAR Calculate", select: "2" },
    { roleId: 19, roleName: "ICAAP Calculate", select: "2" },
    { roleId: 20, roleName: "Capital Planning Calculate", select: "2" },
  ];
}

export function getAllReportName() {
  return getRawListRole().map((item) => item.roleName);
}

export function getAccountFullName() {
  const currentAcc = Http.getCurrentUserInfo();
  return currentAcc.Fullname || "";
}

export function getCurrentAccountTypeName() {
  const currentAcc = Http.getCurrentUserInfo();
  return getAccountTypeName(currentAcc.AccountType);
}

export function getCurrentRoleGroupName() {
  return RoleGroupName;
}

export function showAlert({ title, content, onOk }) {
  AlertFunc && AlertFunc({ title, content, onOk });
}

export function setAlertFunc(func) {
  AlertFunc = func;
}

export function removeAlertFunc() {
  AlertFunc = null;
}

export function round2Number(num) {
  if (num >= 10) return num + "";
  return "0" + num;
}

export function getTimeDisplay(timestr) {
  const timezone = (new Date().getTimezoneOffset() * -1) / 60;
  const timeObj = new Date(timestr);
  timeObj.setHours(timeObj.getHours() + timezone);

  const date = round2Number(timeObj.getDate());
  const month = round2Number(timeObj.getMonth());
  const year = round2Number(timeObj.getFullYear());
  const hour = round2Number(timeObj.getHours());
  const minute = round2Number(timeObj.getMinutes());
  const second = round2Number(timeObj.getSeconds());

  return `${date}/${month}/${year} ${hour}:${minute}:${second}`;
}

export const ENUMS = {
  FILE_STATUS: {
    NONE: "NONE",
    IN_PROGRESS: "IN_PROGRESS",
    WAITING_FOR_APPROVAL: "WAITING_FOR_APPROVAL",
    APPROVED: "APPROVED",
    REJECTED: "REJECTED",
    CALCULATING: "CALCULATING",
    CALCULATED: "CALCULATED",
    CALCULATION_STOPPED: "CALCULATION_STOPPED",
  },
  UPLOAD_TYPE: {
    UPLOAD_ONLY: "UPLOAD_ONLY",
    UPLOAD_AND_MERGE: "UPLOAD_AND_MERGE",
  },
};

// Capital Planning
// CAPITAL_PLANNING
export const ROLE_DEFINE_MAP = {
  DISABLE: "Disable",
  NO_ROLE: "No Role",
  CREATE_USER: "Create User",
  UPDATE_USER: "Update User",
  DELETE_USER: "Delete User",
  EDIT_PARAMETERS: "Edit Parameters",
  UPLOAD_FILES: "Upload Files",
  CAR_UPLOAD_FILES: "CAR Upload Files",
  ICAAP_UPLOAD_FILES: "ICAAP Upload Files",
  CAPITAL_PLANNING_SAVE: "Capital Planning Save",
  APPROVAL_FILES: "Approval Files",
  CAR_APPROVAL_FILES: "CAR Approval Files",
  ICAAP_APPROVAL_FILES: "ICAAP Approval Files",
  CALCULATE: "Calculate",
  CAR_CALCULATE: "CAR Calculate",
  ICAAP_CALCULATE: "ICAAP Calculate",
  CAPITAL_PLANNING_CALCULATE: "Capital Planning Calculate",
  VIEW_REPORT: "View Report",
  ICAAP_VIEW_REPORT: "ICAAP View Report",
  CAR_VIEW_REPORT: "CAR View Report",
  CAPITAL_PLANNING_VIEW_REPORT: "Capital Planning View Report",
  CAR_DELETE_REPORT: "CAR Delete Report",
  ICAAP_DELETE_REPORT: "ICAAP Delete Report",
  CAPITAL_PLANNING_DELETE_REPORT: "Capital Planning Delete Report",
  DELETE_REPORT: "Delete Report",
  CREATE_ROLE: "Create Role",
  UPDATE_ROLE: "Update Role",
};

export const FILE_STATUS_MAP = {
  WAITING_FOR_APPROVAL: "Waiting for approval",
  APPROVED: "Approved",
  REJECTED: "Rejected",
  CALCULATING: "Calculating",
  CALCULATED: "Calculated",
  CALCULATION_STOPPED: "Calculation Stopped",
  IN_PROGRESS: "In Progress",
  NONE: "None",
};

export const FILE_STATUS_MAP_ENUM = {
  None: "NONE",
  "In Progress": "IN_PROGRESS",
  "Waiting for approval": "WAITING_FOR_APPROVAL",
  Approved: "APPROVED",
  Rejected: "REJECTED",
  Calculating: "CALCULATING",
  Calculated: "CALCULATED",
  "Calculation stopped": "CALCULATION_STOPPED",
};

export const UPLOAD_TYPE_MAP = {
  UPLOAD_ONLY: "Upload only",
  UPLOAD_AND_MERGE: "Upload and merge",
};

export function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export function isReportFile(fileName) {
  let isTrue = false;

  Object.values(REPORT_NAME_MAPPING).forEach((name) => {
    if (fileName && fileName.includes(name)) {
      isTrue = true;
      return;
    }
  });

  return isTrue;
}

export function isOutputFile(fileName) {
  return !isReportFile(fileName);
}

export function isIntermediateOutputFiles(fileName) {
  let isTrue = false;

  INTERMEDIATE_OUTPUT_FILES.forEach((name) => {
    if (fileName && fileName.includes(name)) {
      isTrue = true;
      return;
    }
  });

  return isTrue;
}

export const COMPONENT = {
  CAR: "car",
  ICAAP: "icaap",
  CAPITAL_PLANING: "capital-planing",
  RAROC: "raroc",
  PRICING: "pricing",
};



// WEBPACK FOOTER //
// src/utils/business.js